module.exports = __webpack_public_path__ + "static/media/SB.40725ee9.svg";